import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import Loader from "../../common/loading-widgets/Loader.js";
import JobSearchItem from "./JobSearchItem.js";
import JobSearchResultList from "./JobSearchResultList.js";
import JobSearchPane from "./JobSearchPane.js";
import "./JobListWithSearchPane.scss"


export default function JobListWithSearchPane(props) {
  const { initialSearchFilters, initialSortBy, initialPageSize } = props;

  const [searchFilters, setSearchFilters] =
    React.useState(initialSearchFilters);
  const [sortValue, updateSortValue] = React.useState(initialSortBy);
  const [pageSizeValue, updatePageSizeValue] = React.useState(initialPageSize);

  const searchResult = React.useMemo(() => <JobSearchItem searchFilters={searchFilters} />, [searchFilters]);

  // RENDER
  return (
    <div className="JobListWithSearchPane">
      <Row>
        <Col>
          <JobSearchPane
            searchFilters={searchFilters}
            updateSearchFilters={setSearchFilters}
            sortValue={sortValue}
            updateSortValue={updateSortValue}
            pageSizeValue={pageSizeValue}
          />
        </Col>

      </Row>
      <Row className = "rowFilterContainer">
        <Col className = "JobSearchResultListContainer">
          <Loader>
            <JobSearchResultList
              resultComponent={searchResult}
              searchFilters={searchFilters}
              sortValue={sortValue}
              pageSizeValue={pageSizeValue}
              updatePageSizeValue={updatePageSizeValue}
            />
          </Loader>
        </Col>
      </Row>
    </div>
  );
}
